var FilterableResult = require('../General/FilterableResult').FilterableResult;
import { AbconetApi } from '../General/AbconetApi';
import moment from "moment";
import { generateUptime, secondsToReadableTime, generateRuntime } from "../../Helper"

const NextService = ({ serviceCollection, bookNowLink }) => {
    var futureServiceCollection = [];

    if (serviceCollection) {
        futureServiceCollection = serviceCollection.filter((service) => {
            return service.workflowStatus != 'Closed' && service.workflowStatus != 'Resolved';
        });
    }

    if (futureServiceCollection.length > 0) {
        return moment(futureServiceCollection[0].startDate).format("DD/MM/YYYY");
    } else {
        return <a href={bookNowLink}>Book Now</a>;
    }
}

export class EquipmentListing extends React.Component {

    constructor(props) {
        super(props);
        this.filterableResult = React.createRef();
        this.state = {
          
        };
    }




    renderRows(row) {
        var installationDate = row.installationDate ? moment(row.installationDate) : null;

        var uptime = generateUptime(installationDate, row.serviceCollection);
        var data = generateRuntime(row.runtimeHistory, installationDate);
        var siteName = null;
        if (row.address) {
            siteName = row.address.name;

            if (siteName == null) {
                siteName = row.address.addressLine1;
            }
        }

        return (
            <div className="item pl-0 pr-0" key={row.id}>
                <div className="row">
                    <div className="col-6 d-md-none">
                        <strong>Serial:</strong>
                    </div>
                    <div className="col-6 col-md-2 text-sm-left text-md-center" style={{ whiteSpace: 'nowrap' }}>
                        <a href={`/equipment/${row.id}`}>{row.serialNumber}</a>
                    </div>
                    <div className="col-6 d-md-none">
                        <strong>Site:</strong>
                    </div>
                    <div className="col-6 col-md-2 text-sm-left text-md-center">
                        {siteName}
                    </div>
                    <div className="col-6 d-md-none">
                        <strong>Make / Model:</strong>
                    </div>
                    <div className="col-6 col-md-2 text-sm-left text-md-center" style={{ overflowWrap: 'break-word' }}>
                        {row.make} / {row.model}
                    </div>
                    <div className="col-6 d-md-none">
                        <strong>Last Contacted:</strong>
                    </div>
                    <div className="col-6 col-md-2 text-sm-left text-md-center">
                        {row.lastKnownLocationDate && moment(row.lastKnownLocationDate).format("DD/MM/YYYY")}
                    </div>
                    <div className="col-6 d-md-none">
                        <strong>Next Service:</strong>
                    </div>
                    <div className="col-6 col-md-2 text-sm-left text-md-center">
                        <NextService serviceCollection={row.serviceCollection} bookNowLink={`/services/create/${row.id}`} />
                    </div>
                    <div className="col-6 d-md-none">
                        <strong>Utilization / Uptime:</strong>
                    </div>
                    <div className="col-6 col-md-2 text-sm-left text-md-center">
                        {isNaN(data.allTimeUtilization) || !isFinite(data.allTimeUtilization) ? "" : `${data.allTimeUtilization}%/`}
                        {uptime.allTime}%
                    </div>
                </div>
            </div>
        );
    }


    renderData(resultCollection) {
        return (
            <div className="list-group">

                <div className="row header d-none d-md-flex">
                    <div className="col-6 col-md-2 col-hd text-center">
                        Serial
                    </div>
                    <div className="col-6 col-md-2 col-hd text-center">
                        Site
                    </div>
                    <div className="col-6 col-md-2 col-hd text-center">
                        Make/Model
                    </div>
                    <div className="col-6 col-md-2 col-hd text-center">
                        Last Contacted
                    </div>
                    <div className="col-6 col-md-2 col-hd text-center">
                        Next Service
                    </div>
                    <div className="col-6 col-md-2 col-hd text-center">
                        Utilization/Uptime
                    </div>
                </div>
                {resultCollection.map(this.renderRows.bind(this))}
            </div>

        );
    }

    render() {
        var initialState = this.props.initialState;
        var baseUrl = null;

        if (this.props.limitToSite != null) {
            initialState = {
                filterCollection: [{
                    "type": "Dropdown",
                    "value": this.props.limitToSite.id,
                    "name": "siteList",
                }],
                resultMetadata: {
                    pageSize: 5
                },

                hideFilter: true
            };
            baseUrl = "/equipment/"
        }

        return (
            <div className="equipment-listing">
                <FilterableResult ref={this.filterableResult} initialState={initialState} renderData={this.renderData.bind(this)} baseUrl={baseUrl} mainAltClass={"col-lg-10 col-12"} filterAltClass={"col-lg-2"} />
            </div>
        );
    }

}